export default "__VITE_ASSET__4wGf4mmg__"